var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sc-search-v2',{ref:"form1",attrs:{"name":"提交人信息","columns":_vm.columns,"result":_vm.result,"LS":_vm.LS,"btn":_vm.btn,"size":_vm.size},on:{"update:result":function($event){_vm.result=$event},"change":_vm.changeFn,"search":_vm.clickFn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }